import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { detect, fromStorage, fromNavigator } from '@lingui/detect-locale';
import { useEffect } from 'react';
import { en, ru } from 'make-plural/plurals';

export const locales = {
    en: 'en',
    ru: 'ru',
};

export const DEFAULT_LOCALE = 'ru';
export const LANGUAGE_STORAGE_KEY = 'lang';

i18n.loadLocaleData({
    [locales.en]: { plurals: en },
    [locales.ru]: { plurals: ru },
});

if (typeof i18n.locale === 'undefined') {
    i18n.loadLocaleData(DEFAULT_LOCALE, { plurals: ru });
    i18n.load(DEFAULT_LOCALE, {});
    i18n.activate(DEFAULT_LOCALE);
}

export function detectLocale () {
    const locale = detect(
        fromStorage(LANGUAGE_STORAGE_KEY),
        fromNavigator(),
        DEFAULT_LOCALE
    );

    return locale.split('-')[0];
}

export async function dynamicActivate (locale) {
    const { messages } = await import(`@lingui/loader!./locales/${locale}/messages.po`);

    i18n.load(locale, messages);
    i18n.activate(locale);
}

export function LocalizationProvider ({ children }) {
    useEffect(() => {
        dynamicActivate(detectLocale());
    }, []);

    return (
        <I18nProvider
            i18n={i18n}
            forceRenderOnLocaleChange={true}
        >
            {children}
        </I18nProvider>
    );
}
